import React from 'react';
import { Grid, Typography, Box, makeStyles } from '@material-ui/core';
import palette from 'theme/palette';
import i18n from 'i18n';
import styles from '../styles';

const useStyles = makeStyles(styles);

interface DashboardModalLegendProps {
  color: string;
  label: string;
  count: number;
}

const DashboardModalLegend = ({
  color,
  label,
  count,
}: DashboardModalLegendProps) => {
  const classes = useStyles();
  return (
    <Grid item className={classes.displayFlex}>
      <div
        style={{
          height: 10,
          width: 30,
          border: `1px solid ${color}`,
          backgroundColor: color,
          margin: '0px 6px',
        }}
      ></div>
      <Typography className={classes.titleDoughnut} component="div">
        {`${i18n.t(label)}: `}
        <Box
          color={palette.blue}
          fontWeight="bold"
          display="flex"
          alignItems="center"
        >
          {count || 0}
        </Box>
      </Typography>
    </Grid>
  );
};

export default DashboardModalLegend;
